import lang from "../../../Translation/Ladning.json"; 

const Performance = () => {
  const text = lang.Performance; 

  const officers = [
    { name: "Haized", bayaran: 3500, jur: 4800 },
    { name: "Aina", bayaran: 4200, jur: 5200 },
    { name: "Farid", bayaran: 2950, jur: 4100 },
    { name: "Nadia", bayaran: 5100, jur: 6100 },
    { name: "Rafiq", bayaran: 3800, jur: 4900 },
  ];

  return (
    <div className="p-5 rounded-md shadow-md border bg-white">
      <h4 className="mb-3 text-lg font-semibold uppercase">
        {text.title}
      </h4>

      <table className="w-full border-collapse">
        <thead>
          <tr className="text-gray-700">
            <th className="py-2 px-3 text-left">{text.name}</th>
            <th className="py-2 px-3 text-left">{text.total_payment}</th>
            <th className="py-2 px-3 text-left">{text.jur}</th>
          </tr>
        </thead>

        <tbody>
          {officers.map((officer, index) => (
            <tr
              key={index}
              className="border-b hover:bg-gray-50 transition duration-200"
            >
              <td className="py-2 px-3">{officer.name}</td>
              <td className="py-2 px-3">
                RM {Number(officer.bayaran).toLocaleString()}
              </td>
              <td className="py-2 px-3">
                {Number(officer.jur).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Performance;
